import { render, staticRenderFns } from "./FeatureCardTreeview.vue?vue&type=template&id=0b5becfb&"
import script from "./FeatureCardTreeview.vue?vue&type=script&lang=js&"
export * from "./FeatureCardTreeview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports